<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2024-07-02 17:38:28
-->
<template>
  <div>
    <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">下载中心</div>
      </div>
    </div> -->
    <div class="content colorlist">
      <!-- 循环navlist 对应显示内容 -->
      <div class="tabdiv">
        <ul>
          <!-- <template v-for="(item, index) in navlist">
            <li v-if="index == tid" class="on" :key="index">{{ item.name }}</li>
          </template> -->
          <li class="on">{{ leftNavName }}</li>
        </ul>
        <div class="tablist">
          <ul>
            <li
              @click="toinfo(item.id)"
              v-for="(item, index) in datalist"
              :key="index"
            >
              <p>
                {{ item.title }}
              </p>
              <span>{{
                item.createDate ? item.createDate.split(" ")[0] : ""
              }}</span>
            </li>
          </ul>
        </div>
        <!-- <div class="tablist" v-if="tid == 1">
          <ul>
            <li @click="toinfo(1)">
              <p>
                212323华能新能源辽宁分公司下属风电场升压站电气类消防改造工程招标公告
              </p>
              <span>2020-09-16</span>
            </li>
          </ul>
        </div> -->
        <div class="search">
          <el-input
            placeholder="请输入关键字"
            clearable
            v-model="keyword"
            size="small"
            class="input-with-select"
          >
            <el-button
              slot="append"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div class="pageno">
          <el-pagination
            background
            :current-page="pageno"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
      tid: "",
      pageno: 1,
      datalist: [],
      total: 0,
      leftNavName: ""
      // navlist: [
      //   { name: "通知公告" },
      //   { name: "下载专区" },
      //   { name: "常见问题" },
      //   { name: "企业资讯" },
      //   { name: "公司业务" }
      // ]
    };
  },
  watch: {
    $route: {
      handler() {
        this.tid = this.$route.query.tid;
        this.pageno = this.$route.query.pageno - 0;
        this.keyword = this.$route.query.keyword || "";
        var nav = JSON.parse(localStorage.getItem("nav"));

        this.leftNavName = nav.filter(item => {
          return item.parent.code === "websiteDownload";
        })[0].parent.name;
        this.getinfo();
      },
      immediate: true
    }
  },
  methods: {
    search() {
      this.$router.push({
        path: "/service/service",
        query: { tid: this.tid, pageno: 1, keyword: this.keyword }
      });
    },
    getinfo() {
      this.$get(
        "/website/getServiceCenterPageList?menuCode=websiteDownload&type=3&limit=10&page=" +
          this.pageno +
          "&title=" +
          this.keyword
      ).then(res => {
        this.datalist = res.data.list;
        this.total = res.data.total;
      });
    },
    // toinfo(id) {
    //   var url = this.$baseURL + "/website/webSiteDownloadZipFile?id=" + id;
    //   window.open(url);
    // },
    toinfo(id) {
      this.$router.push({
        path: "/service/serviceinfo",
        query: { tid: this.tid, id: id }
      });
    },
    handleCurrentChange(val) {
      // window.scrollTo(0, 0);
      this.$router.push({
        path: "/service/service",
        query: { tid: this.tid, pageno: val, keyword: this.keyword }
      });
    }
    // changetab(index) {
    //   this.$router.push({
    //     path: "/service/service",
    //     query: { tid: index, pageno: 1 }
    //   });
    // }
    // changetabdiv(index) {
    //   this.$router.push({
    //     path: "/service/service",
    //     query: { tid: this.tid,  pageno: 1 }
    //   });
    // }
  }
};
</script>
<style scoped>
.pageno {
  padding-top: 20px;
  text-align: right;
}
.tablist {
  width: 100%;
  background: #f5fafe;
  margin-top: 20px;
}
.tablist ul {
  width: 100%;
}
.tablist ul li {
  height: 60px;
  display: flex;
  padding: 0 15px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px dashed #ccc;
}
.tablist li p {
  font-size: 15px;
  flex: 1;
  line-height: 20px;
}
.tablist li span {
  color: #666;
  width: 120px;
  text-align: right;
  font-size: 16px;
}
.search {
  width: 300px;
  position: absolute;
  right: 0;
  top: 10px;
}
.tabdiv {
  position: relative;
}
.tabdiv > ul {
  border-bottom: 1px solid rgb(104, 144, 206);
}
.tabdiv > ul li {
  width: 200px;
  height: 76px;
  text-align: center;
  line-height: 76px;
  display: inline-block;
  border: 1px solid #ddd;
  background: url("~@/assets/images/navbg.png") center center no-repeat;
  background-size: 100% 76px;
  font-size: 20px;
  color: #fff;
}

.content {
  width: 1200px;
  margin: 0 auto;
  padding: 0;
  float: none;
  margin-top: 20px;
  background: #fff;
}
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}
.secondnav .nav {
  float: right;
  height: 80px;
  display: flex;
  align-items: center;
}
.secondnav .nav a {
  display: inline-block;
  padding: 10px 15px;
  background: rgb(102, 119, 170);
  margin-left: 20px;
  font-size: 16px;
  color: #fff;
}
.secondnav .nav a.on,
.secondnav .nav a:hover {
  background: #9c1f21;
}
.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
</style>
